import { Dispatch, HTMLAttributes, SetStateAction } from 'react';
import Modal from '../Modal';
import { cn } from '@/lib/utils';
import CheckSuccess from '../Icons/CheckSuccess';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  modalIsOpen: boolean;
  paymentSuccess?: boolean;
  preventOutsideClick?: boolean;
  setModalIsOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SuccessModal({
  modalIsOpen,
  setModalIsOpen,
  title,
  paymentSuccess = false,
  preventOutsideClick = false,
  description,
  children,
}: Props) {
  return (
    <Modal.Root open={modalIsOpen} onOpenChange={setModalIsOpen}>
      <Modal.Content
        hideXButton={paymentSuccess}
        preventOutsideClick={preventOutsideClick}
        contentCustomClass="md:!w-1/2 md:!mt-[-15vh]"
        onOpenChange={setModalIsOpen}>
        <div className="text-center p-[20px]">
          <div
            className={cn({
              'text-start flex flex-row items-center gap-x-[16px] mb-[20px]':
                paymentSuccess,
            })}>
            <div
              className={cn('relative w-14 h-14 mb-4 mx-auto', {
                'm-0': paymentSuccess,
              })}>
              <CheckSuccess />
            </div>
            <h3
              className={cn(
                'mb-[20px] font-semibold text-success text-[26px]',
                {
                  'mb-0 font-semibold text-4xl': paymentSuccess,
                },
              )}>
              {title}
            </h3>
          </div>
          <p
            className={cn('text-lg', {
              'text-start': paymentSuccess,
            })}>
            {description}
          </p>
          {children}
        </div>
      </Modal.Content>
    </Modal.Root>
  );
}
